export class LocationDetails {
  country: string = '';
  countryCode: string = '';
  regionCity: string = '';
  street: string = '';
  number: string = '';
  postalCode: string = '';
  latitude: number | null = null ;
  longitude: number | null = null;
}
